import PropTypes from 'prop-types';
import React from 'react';

function ButtonAsLink({ href, onClick, children, className }) {
  const handleClick = (e) => {
    e.preventDefault();
    if (onClick) {
      onClick();
    }
  };

  return (
    <>
      <a className={`${className} link`} href={href} onClick={handleClick}>
        {children}
      </a>
      <style jsx>
        {`
          .link {
            text-decoration: underline;
            white-space: nowrap;
            background: none;
            border: none;
            padding: 0;
            cursor: pointer;
            color: grey;
          }
        `}
      </style>
    </>
  );
}

ButtonAsLink.propTypes = {
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
  href: PropTypes.string,
  onClick: PropTypes.func,
};

export default ButtonAsLink;
